import { type RegisteredRouter, RouterProvider } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { getUserClaimsQuery, useApi } from "@/api";
import LoadingPane from "@/components/LoadingPane";

interface HookedRouterProviderProps {
  router: RegisteredRouter;
}

export function HookedRouterProvider({ router }: HookedRouterProviderProps) {
  const apiHook = useApi();
  const { data: userClaim, isLoading: isLoadingUserClaim } = useQuery(
    getUserClaimsQuery(apiHook.secureAxios)
  );

  // Inject the returned value from the hook into the router context
  return isLoadingUserClaim ? (
    <LoadingPane />
  ) : (
    <RouterProvider router={router} context={{ apiHook, userClaim }} />
  );
}
